import React, { ReactNode } from 'react';
import { Card, CardContent } from '../ui/card';

/**
 * Interface representing the props for the FormContainer component.
 *
 * - children - The React nodes (elements) to be rendered inside the form container.
 */
interface FormContainerProps {
  children: ReactNode;
}

/**
 * FormContainer component that provides a styled container for form elements.
 * It wraps its children with a styled Card component from Shadcn/UI for consistent
 * form presentation across the application.
 *
 * @param children The React nodes to be displayed inside the form container.
 */
const FormContainer: React.FC<FormContainerProps> = ({ children }) => (
  <Card className='w-4/5 max-w-3xl mx-auto my-5 bg-gray-50'>
    <CardContent className='pt-6'>{children}</CardContent>
  </Card>
);

export default FormContainer;
